module.exports = __webpack_public_path__ + "img/headBannerImg.5c40ef82.png";